
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins],
  layout: 'base',
  data() {
    return {
      seoTitle: 'О проекте | Мегасреда',
      seoDescription:
        'Сообщество объединяет бухгалтеров, юристов и предпринимателей.',

      seoImage: {
        url: 'https://megasreda.ru/img/about/advertisement.jpg',
        urlVk: 'https://megasreda.ru/img/about/advertisement-vk.jpg',
        urlTw: 'https://megasreda.ru/img/about/advertisement.jpg',
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      },
    }
  },
}
